// src/router/config.ts
const routes = [
  {
    path: ["/", "/home"],
    exact: true,
    component: "Home",
  },
  {
    path: "/dashboard",
    exact: true,
    component: "Dashboard",
  },
  {
    path: "/roadmap",
    exact: true,
    component: "Roadmap",
  },
  {
    path: "/find-coach",
    exact: true,
    component: "CoachFinder",
  },
  {
    path: "/terms",
    exact: true,
    component: "Terms",
  },
  {
    path: "/privacy",
    exact: true,
    component: "Privacy",
  },
];

export default routes;